export default __webpack_public_path__ + "static/media/Tholasi.582b8ccf.jpg";